import { render, staticRenderFns } from "./FiltersGroupsAdd.vue?vue&type=template&id=0e74f5b8"
import script from "./FiltersGroupsAdd.vue?vue&type=script&lang=js"
export * from "./FiltersGroupsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports